export default "__VITE_ASSET__cb57ae88__"